import React from 'react';
import { Link } from 'react-router-dom';
import { ClockIcon, MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { Logo } from './Logo';
import { services } from '../data/services';
import { company } from '../data/company';
const companyLinks = [{
  label: 'About Us',
  to: '/about'
}, {
  label: 'Fiduciary Services',
  to: '/services'
}, {
  label: 'Contact Us',
  to: '/contact'
}];
const legalLinks = [{
  label: 'Privacy Policy',
  to: '/privacy-policy'
}, {
  label: 'Terms of Use',
  to: '/terms-of-use'
}, {
  label: 'Disclaimer',
  to: '/disclaimer'
}];
export function Footer() {
  return <footer className="bg-navy-950 text-navy-200" data-id="element-76" data-mp="3lf58uv9exxoi">
      <div className="mx-auto max-w-content px-6 py-16 lg:px-8" data-id="element-77" data-mp="3lggb2qn7mxdi">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr]" data-id="element-78" data-mp="3qc40n75ltsjj">
          <div className="max-w-sm" data-id="element-79" data-mp="29yxbr9cr3ek8">
            <Logo variant="light" data-id="element-80" data-mp="29xvqyd5xndpb" />
            <p className="mt-6 text-[15px] leading-relaxed text-navy-300" data-id="element-81" data-mp="2ey09s9ubckip">
              {company.name} provides professional fiduciary, trust, estate,
              conservatorship and care administration support for individuals,
              families and beneficiaries.
            </p>
            <ul className="mt-7 space-y-3 text-[15px] text-navy-300" data-id="element-82" data-mp="3v7q4xmoa8feg">
              <li className="flex items-start gap-3" data-id="element-83" data-mp="3v91bfu944199">
                <PhoneIcon className="mt-1 h-4 w-4 shrink-0 text-gold-300" aria-hidden="true" data-id="element-84" data-mp="3q8dk17gz1iei" />
                <a href={company.phoneHref} className="transition-colors duration-150 ease-out hover:text-white" data-id="element-85" data-mp="80xjq7w8kzj3">
                  {company.phoneDisplay}
                </a>
              </li>
              <li className="flex items-start gap-3" data-id="element-86" data-mp="ct783jhpdrj9">
                <MailIcon className="mt-1 h-4 w-4 shrink-0 text-gold-300" aria-hidden="true" data-id="element-87" data-mp="cvto87intfd3" />
                <a href={company.emailHref} className="break-all transition-colors duration-150 ease-out hover:text-white" data-id="element-88" data-mp="mspmzliran4g">
                  {company.email}
                </a>
              </li>
              <li className="flex items-start gap-3" data-id="element-89" data-mp="ys3e2atp4syg">
                <MapPinIcon className="mt-1 h-4 w-4 shrink-0 text-gold-300" aria-hidden="true" data-id="element-90" data-mp="13t0sccbl52uo" />
                <address className="not-italic leading-relaxed" data-id="element-91" data-mp="18m3rr131n6is">
                  {company.addressLine1}
                  <br data-id="element-92" data-mp="1cnyp5uhuszra" />
                  {company.addressLine2}
                </address>
              </li>
              <li className="flex items-start gap-3" data-id="element-93" data-mp="1mjsb24hgq5lq">
                <ClockIcon className="mt-1 h-4 w-4 shrink-0 text-gold-300" aria-hidden="true" data-id="element-94" data-mp="1mkbj8thb9fmk" />
                <span className="leading-relaxed" data-id="element-95" data-mp="3ob57041gd35n">{company.hours}</span>
              </li>
            </ul>
          </div>

          <div data-id="element-96" data-mp="3t9ge470d4zk6">
            <h2 className="text-[12px] uppercase tracking-[0.2em] text-gold-300" data-id="element-97" data-mp="3tb189virmghi">
              Fiduciary Services
            </h2>
            <ul className="mt-5 space-y-2.5" data-id="element-98" data-mp="2ah84gub5z6ug">
              {services.map(service => <li key={service.slug} data-id="element-99" data-mp="25n3yad9q32uf">
                  <Link to={service.path} className="text-[15px] text-navy-300 transition-colors duration-150 ease-out hover:text-white" data-id="element-100" data-mp="21mjy10turj42">
                    {service.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col gap-10" data-id="element-101" data-mp="2pdfq7z280gbu">
            <div data-id="element-102" data-mp="2pajri8ijtnmc">
              <h2 className="text-[12px] uppercase tracking-[0.2em] text-gold-300" data-id="element-103" data-mp="2kd1gmckz0ybp">
                Company
              </h2>
              <ul className="mt-5 space-y-2.5" data-id="element-104" data-mp="2fd5b28wmkyu1">
                {companyLinks.map(link => <li key={link.to} data-id="element-105" data-mp="18z5ziyaiafhu">
                    <Link to={link.to} className="text-[15px] text-navy-300 transition-colors duration-150 ease-out hover:text-white" data-id="element-106" data-mp="18w1nxfupohh5">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </div>
            <div data-id="element-107" data-mp="2ivb3w5ijphah">
              <h2 className="text-[12px] uppercase tracking-[0.2em] text-gold-300" data-id="element-108" data-mp="2ivugr7tc9fhn">
                Legal
              </h2>
              <ul className="mt-5 space-y-2.5" data-id="element-109" data-mp="2nunr4rdbwqdl">
                {legalLinks.map(link => <li key={link.to} data-id="element-110" data-mp="3bk8cti0va1qk">
                    <Link to={link.to} className="text-[15px] text-navy-300 transition-colors duration-150 ease-out hover:text-white" data-id="element-111" data-mp="3bhvu32nabncg">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-4 border-t border-white/10 pt-8 sm:flex-row sm:items-center sm:justify-between" data-id="element-112" data-mp="1q4sw4r6vmrqq">
          <p className="text-[13px] text-navy-500" data-id="element-113" data-mp="1v346d313349h">
            © {new Date().getFullYear()} {company.name}. All rights reserved.
          </p>
          <Link to="/disclaimer" className="text-[13px] text-navy-400 transition-colors duration-150 ease-out hover:text-white" data-id="element-114" data-mp="1iltcckfi6y6u">
            Read our full disclaimer
          </Link>
        </div>
      </div>
    </footer>;
}